import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "../local-storage.service";
import { Session } from "src/app/features/login/login";


export const authGuardInjectable = (/*route: ActivatedRouteSnapshot, state: RouterStateSnapshot*/) => {

    const router: Router = inject(Router);
    const localStorageService: LocalStorageService = inject(LocalStorageService);    

    // get the session 
    let tokens = localStorageService.getTokens();

    // if the session is not present the user can't access, he need to login
    if(!tokens) {
        console.warn("User not logged in, redirecting...");
        localStorage.clear();
        return router.navigate(['/login']);
    }

    return true;


}